import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const Root = styled.div`
  max-width: ${unitizedPx(40)};
`;
